export const state = {
  isLoading: false,
  showTabbar: true,
  focusHideEnable: true,
  showTopCouponFilters: false,
  keepAliveIncludes: ['CouponList', 'SearchResult', 'FacilityDetail'],
}

export const mutations = {
  SET_ISLOADING(state, newValue) {
    state.isLoading = newValue
  },
  SET_SHOWTABBAR(state, newValue) {
    state.showTabbar = newValue
  },
  SET_FOCUSHIDEENABLE(state, newValue) {
    state.focusHideEnable = newValue
  },
  SET_SHOWTOPCOUPONFILTERS(state, newValue) {
    state.showTopCouponFilters = newValue
  },
  SET_KEEPALIVEINCLUDES(state, newValue) {
    state.keepAliveIncludes = newValue
  },
}

export const actions = {
  startLoading({ commit, state, rootState }) {
    commit('SET_ISLOADING', true)
  },
  endLoading({ commit, state, rootState }) {
    commit('SET_ISLOADING', false)
  },
  showTabbar({ commit, state, rootState }) {
    commit('SET_SHOWTABBAR', true)
  },
  hideTabbar({ commit, state, rootState }) {
    commit('SET_SHOWTABBAR', false)
  },
  showTopCouponFilters({ commit, state, rootState }) {
    commit('SET_SHOWTOPCOUPONFILTERS', true)
  },
  enableFocusHide({ commit, state, rootState }) {
    commit('SET_FOCUSHIDEENABLE', true)
  },
  disableFocusHide({ commit, state, rootState }) {
    commit('SET_FOCUSHIDEENABLE', false)
  },
  enableCouponDetailAlive({ commit, state, rootState }) {
    const newIncludes = [...state.keepAliveIncludes]
    if (!newIncludes.includes('CouponDetail')) {
      newIncludes.push('CouponDetail')
    }
    commit('SET_KEEPALIVEINCLUDES', newIncludes)
  },
  disableCouponDetailAlive({ commit, state, rootState }) {
    const newIncludes = [...state.keepAliveIncludes]
    const index = newIncludes.indexOf('CouponDetail')
    if (index > -1) {
      newIncludes.splice(index, 1)
    }
    commit('SET_KEEPALIVEINCLUDES', newIncludes)
  },
  enableMapAlive({ commit, state, rootState }) {
    const newIncludes = [...state.keepAliveIncludes]
    if (!newIncludes.includes('Map')) {
      newIncludes.push('Map')
    }
    commit('SET_KEEPALIVEINCLUDES', newIncludes)
  },
  disableMapAlive({ commit, state, rootState }) {
    const newIncludes = [...state.keepAliveIncludes]
    const index = newIncludes.indexOf('Map')
    if (index > -1) {
      newIncludes.splice(index, 1)
    }
    commit('SET_KEEPALIVEINCLUDES', newIncludes)
  },
}
